export default __webpack_public_path__ + "static/media/fresh.f129df54.svg";